import { DiscoPricingItemMapper } from "./disco-pricing-item.mapper";
import { BillingLine } from '../../../billing-line/billing-line.model';
import { ProductV2 } from '../../../productv2/productv2.model';
import { ProductPricingV2 } from '../../../productv2/productpricingv2.model';
import { DiscoLsRenewalPricingItemInitializer } from "src/app/components/article-selection-form/disco/ls/disco.ls.renewal-pricing-item-initializer";


export class DiscoLsPricingItemMapper extends DiscoPricingItemMapper {

    mapPricingItemFromProduct(product: ProductV2, cc: BillingLine, referential: any, idx: string) {
        let pricingItem = this.mapProductToPricingItemWithCustomerContract(product, cc, idx);
        const frDiscoPricingItemInitializer = new DiscoLsRenewalPricingItemInitializer(new DiscoPricingItemMapper(true));

        const prefilledInputs = frDiscoPricingItemInitializer.getPrefilledInputs(product.priceList?.productPricings, referential, cc);
        prefilledInputs['exchangeRules'] = prefilledInputs['exchangeRules']
            .sort((a, b) => a.key?.localeCompare(b.key))
            .map(({ key, value }) => ({
                key: key?.toLowerCase(),
                value: value?.toLowerCase()
            }));
        const userInputs = frDiscoPricingItemInitializer.initUserInputs(cc, prefilledInputs, pricingItem);
        return pricingItem.copyWith({ userInputs, prefilledInputs });
    }

    findMatchingProductPricing(productPricings: ProductPricingV2[], customerContract: BillingLine) {
        return productPricings?.find(pp => pp.productPricingDetails['frequency'] === customerContract.serviceFrequency
            && pp.productPricingDetails['exchangeRule'] === customerContract.exchangeRule
            && Number(pp.productPricingDetails['quantityMin']) <= customerContract.weeklyQuantity
            && Number(pp.productPricingDetails['quantityMax']) >= customerContract.weeklyQuantity
        );
    }

    completeProductPricingsWithProduct(cmcProduct: ProductV2, product: ProductV2) {

        let standardProductPricings = this.getStandardProduct(cmcProduct.priceList.productPricings, product.priceList?.productPricings);
       if(standardProductPricings){
            standardProductPricings.forEach(pp => {
                pp['type'] = 'STANDARD';
            });
            cmcProduct.priceList.productPricings = cmcProduct.priceList.productPricings.concat(standardProductPricings);
            cmcProduct['isCmcWithStandardProductPricing'] = true;
        }
    }

    getStandardProduct(cmcProductPricings: ProductPricingV2[], standardProductPricings: ProductPricingV2[]): ProductPricingV2[] {
        return standardProductPricings.filter(standardProductPricing =>
            !cmcProductPricings.some(cmcProductPricing =>
                cmcProductPricing.productPricingDetails['frequency'] === standardProductPricing.productPricingDetails['frequency']
                && cmcProductPricing.productPricingDetails['exchangeRule'] === standardProductPricing.productPricingDetails['exchangeRule']
            )
        );
    }

    getPrefilledInputs(cc: BillingLine, referential: any, productPricings: ProductPricingV2[]): any {

        let prefilledInputs = super.getPrefilledInputs(cc, referential, productPricings);
        const exchangeRule = { key: cc.exchangeRule, value: cc.exchangeRule };
        Object.assign(prefilledInputs, {
            exchangeRules: [exchangeRule]
        })
        return prefilledInputs;
    };

    extendsDevicePricingItemUserInputs(userInputs: any, cc: BillingLine): any {
        const exchangeRule = { key: cc.exchangeRule, value: cc.exchangeRule };
        Object.assign(userInputs, {
            quantity: cc.weeklyQuantity,
            exchangeRule: exchangeRule,
        })
        return userInputs;
    }

}
